import { sha256 } from 'crypto-hash';

// Builds a delegate's join code: CONFCODE-T-xxxxxx, where xxxxxx is the last 6 characters
// of sha256(lowercased email + ticket class). Must match validateJoinCode in functions/functionHelpers.js
// (see faqs/JoinCodes.md).
export async function generateJoinCode(conferenceCode: string, ticketClass: string, email: string): Promise<string> {
  const hash = await sha256(email.trim().toLowerCase() + ticketClass);
  return `${conferenceCode}-${ticketClass}-${hash.slice(-6)}`;
}

// Splits pasted text (one per line, or separated by commas/spaces) into unique lowercased emails
export function parseEmails(text: string): string[] {
  const emails = text
    .split(/[\s,;]+/)
    .map(email => email.trim().toLowerCase())
    .filter(email => email.length > 0);
  return Array.from(new Set(emails));
}

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
